export default __webpack_public_path__ + "static/media/twitter_button.bf2961e8.jpg";